import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentWithoutEdit } from "../../../Common/Table/tableContent";
import service from '../service';
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { attendanceReportSchema } from "../AttendanceReportSchemaReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _, { result, xor } from 'lodash';
import Box from '@material-ui/core/Box';
import Autocomplete from '@material-ui/lab/Autocomplete';

const screenCode = "ATTENDANCEREPORT";

export function AttendanceReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [data, setdata] = useState([]);
    const [employeeCodes, setEmployeeCodes] = useState([]);

    const [csvHeaders, setCsvHeaders] = useState([]);
    const [totalRow, setTotalRow] = useState([])

    const [attendanceDetails, setAttendanceDetailsDetails] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        employeeCode: "",
        fromDate: "",
        toDate: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        employeeCode: "",
        fromDate: "",
        toDate: ""
    })

    const [csvData, setCsvData] = useState([]);

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(attendanceReportSchema).options({ allowUnknown: true });

    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [attendanceDetails.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),

        )
    }, [attendanceDetails.estateID])

    useEffect(() => {
        trackPromise(getPermissions(),
            getEmployeeCodesForDropdown()
        );
    }, []);


    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setAttendanceDetailsDetails({
            ...attendanceDetails,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",

        });
    }
    function handleEstateChange(target) {
        validateInputs(target);

        setAttendanceDetailsDetails({
            ...attendanceDetails,
            estateID: target.value,
            divisionID: "0",

        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setAttendanceDetailsDetails({
            ...attendanceDetails,
            divisionID: target.value,

        });
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setAttendanceDetailsDetails({
            ...attendanceDetails,
            toDate: target.value
        })
    }
    function handleFromDateChange(target) {
        validateInputs(target);

        setAttendanceDetailsDetails({
            ...attendanceDetails,
            fromDate: target.value,

        });
    }

    function handleSearchDropdownChange(data) {

        if (data === undefined || data === null) {
            setAttendanceDetailsDetails({
                ...attendanceDetails,
                employeeCode: ""
            });
        }
        else {
            var nameV = "employeeCode";
            var valueV = data["employeeCode"];

            setAttendanceDetailsDetails({
                ...attendanceDetails,
                employeeCode: valueV.toString()
            });
        }
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, attendanceReportSchema);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWATTENDANCEREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();

        setAttendanceDetailsDetails({
            ...attendanceDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await service.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await service.getEstatesByGroupID(attendanceDetails.groupID);
        setEstates(data);
    }

    async function getDivisionsForDropDown() {
        const data = await service.getDivisionByEstateID(attendanceDetails.estateID);
        setDivisions(data);
    }

    async function getEmployeeCodesForDropdown() {
        const result = await service.getAllEmployeeCodesForDropdown();
        setEmployeeCodes(result);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);
        setButtonHide(true);
        const errorMessages = validate(schema, attendanceDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        getSelectedDropdownValuesForReport(attendanceDetails);
        setIsTableHide(true);

        const results = await service.getPluckingAttendanceDetails(attendanceDetails);

        var copyOfResult = _.cloneDeep(results)

        let result = [];
        let names = [];
        var csvHeaders = [
            { label: "EMP No", value: "employeeCode" },
        ];

        copyOfResult.forEach(x => {

            var estimatedDate = x.estimatedDate.split("T")[0];

            var duplicate = result.find(y => y.employeeCode === x.employeeCode);

            var duplicateName = names.find(y => y === estimatedDate);

            if (duplicateName) {
                duplicateName = estimatedDate;
            }
            else {
                names.push(estimatedDate);
            }

            if (duplicate) {
                duplicate[estimatedDate + ' T'] = parseFloat(x.value1);
                duplicate.employeeCode = x.employeeCode;

            }
            else {
                result.push({
                    [estimatedDate + ' T']: parseFloat(x.value1),
                    employeeCode: x.employeeCode,
                    ttotal: parseFloat(x.value1),

                });
            }

        });
        for (let index = 0; index < names.length; index++) {
            csvHeaders.push({ label: names[index], value: names[index] + ' T' });
        }

        csvHeaders.push({ label: 'Total', value: 'ttotal' });

        var resultOne = await calcCSVRows(result)

        var totOfColss = _.cloneDeep(resultOne)

        let totalResult = [];

        names.forEach(x => {
            let ttotal = 0.0;
            let tAllTotal = 0.0;
            totOfColss.forEach(y => {
                if (y[x + ' T']) {
                    ttotal = ttotal + y[x + ' T']
                }
                if (y['ttotal']) {
                    tAllTotal = tAllTotal + y['ttotal']
                }
            });
            totalResult.push({
                [x + ' T']: ttotal
            })
            totalResult.push({
                ['ttotal']: tAllTotal
            })
        });

        totalResult.push({ "employeeCode": "Total" })

        let finalObj = {};
        for (let i = 0; i < totalResult.length; i++) {
            Object.assign(finalObj, totalResult[i]);
        }

        setTotalRow(finalObj);
        setCsvData(resultOne);
        setCsvHeaders(csvHeaders);

    }

    async function calcCSVRows(result) {
        result.forEach(x => {
            var tTotal = 0.0;
            Object.entries(x).map(([key, value]) => {

                if (key.match(/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])\s+(\bT\b)$/)) {
                    tTotal = tTotal + parseFloat(value);
                }
            });
            x.ttotal = tTotal;
        })
        return result;
    }

    function createFile() {
        var settings = {
            sheetName: 'Plucking Attendance Report',
            fileName: 'PluckingAttendanceReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)

        var copyOfTotalRow = _.cloneDeep(totalRow)

        var newRow1 = {
            employeeCode: "Employee Code : " + [attendanceDetails.employeeCode == "" ? "ALL" : attendanceDetails.employeeCode],
        }
        var newRow2 = {
            employeeCode: "Estate : " + estates[attendanceDetails.estateID],
        }
        var newRow3 = {
            employeeCode: "Group : " + groups[attendanceDetails.groupID],
        }
        var newRow4 = {
            employeeCode: "Division : " + [selectedSearchValues.division],
        }
        var newRow5 = {
            employeeCode: "From Date : " + [attendanceDetails.fromDate],
        }
        var newRow6 = {
            employeeCode: "To Date : " + [attendanceDetails.toDate],
        }

        copyOfCsv.push(copyOfTotalRow, {}, {}, newRow3, newRow2, newRow4, newRow5, newRow6, newRow1)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            employeeCode: employeeCodes[searchForm.employeeCode],
            fromDate: searchForm.searchDate,
            toDate: searchForm.searchDate,
        })

    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Plucking Attendance Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={attendanceDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={attendanceDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Division *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={attendanceDetails.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>

                                </div>
                                <div className="form-group row">
                                    <div className="col-md-3">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-3">
                                        <InputLabel shrink id="employeeCode">Employee No</InputLabel>
                                        <Autocomplete
                                            fullWidth
                                            id="employeeCode"
                                            options={employeeCodes}
                                            getOptionLabel={(option) => option.employeeCode}
                                            size="small"
                                            onChange={(event, value) => handleSearchDropdownChange(value)}
                                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                                        />
                                        {errors["employeeCode"] && <FormHelperText error>{errors["employeeCode"]}</FormHelperText>}
                                    </div>

                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>
                        </div>
                        {csvData.length != 0 ?
                            <div className="card-footer">
                                <input
                                    type="button"
                                    className="btn btn-primary"
                                    value="Excel"
                                    onClick={createFile}
                                />
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
